import { render, staticRenderFns } from "./ReporteLeadsTractos.vue?vue&type=template&id=9877e96a"
import script from "./ReporteLeadsTractos.vue?vue&type=script&lang=js"
export * from "./ReporteLeadsTractos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports